<template>
  <button
    class="btn--loading"
    type="submit"
    :block="true"
    :color="buttonColor"
    @click.prevent="$emit('onSubmit')"
    :disabled="showSpinner"
  >
    <CSpinner
      v-if="showSpinner"
      color="#FFFFFF"
      style="width:1.5rem; height:1.5rem;"
    />
    <div v-if="!showSpinner">{{ texto }}</div>
  </button>
</template>
<script>

export default {
  name: 'LoadingButton',
  props: {
    showSpinner: {
      type: Boolean,
      required: true,
      default: true,
    },
    texto: {
      type: String,
      required: true,
      default: "",
    },
    buttonColor: {
      type: String,
      required: false,
      default: "success",
    }
  },
}
</script>

<style>
.btn--loading {
  background-color: #218838;
  color: #fff;
  border-radius: 5px;
  width: 100%;
  font-weight: bold;
  outline: none;
  padding: 12px 32px;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 15px;
  line-height: 26px;
  justify-content: center;
  display: flex;
  transition: all 0.2s ease;
  align-items: center;
  cursor: pointer;
  -webkit-box-align: center;
  -webkit-box-pack: center;
}
.btn--loading:hover {
  background-color: #396D42;
}
</style>
